"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = void 0;
const _imports_1 = require("./_imports");
exports.ConfigSchema = _imports_1.z.object({
    processOnUpload: _imports_1.z.array(_imports_1.z.enum(_imports_1.Report.UploadDownstreamProcess)),
});
//# sourceMappingURL=DeliverableReportProperty.js.map